import { atom } from 'jotai';

export interface ShippingAddressDto {
  shipTo: string;
  name: string;
  address: string;
  city: string;
  state: string;
  zip: string;
}

export interface BillingShippingDto {
  billingInfo: {
    billTo: string;
    name: string;
    address: string;
    city: string;
    zip: string;
    state: string;
  } | null;
  shipTos: ShippingAddressDto[];
}

export const billingShippingAtom = atom<BillingShippingDto | null>(null);
